import { render, staticRenderFns } from "./WeightUnits.vue?vue&type=template&id=f702d926&scoped=true"
import script from "./WeightUnits.vue?vue&type=script&lang=js"
export * from "./WeightUnits.vue?vue&type=script&lang=js"
import style0 from "./WeightUnits.vue?vue&type=style&index=0&id=f702d926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f702d926",
  null
  
)

export default component.exports